import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=1470c05c&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=js&"
export * from "./warehouse.vue?vue&type=script&lang=js&"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=1470c05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470c05c",
  null
  
)

export default component.exports